import React, { Fragment, useEffect, useState } from 'react';
import Block from '../../../Controls/Scafolding/Block';
import Common from '../../../Shared/Common';

import './../Resources/css/block_champions.css'

import { Row, Col } from 'reactstrap';
import { TextHeader, TextTitle } from '../../../Controls/Digital/TextHeaders';


const Records = (props) => {

    const [blockName, setBlockName] = useState("");
    const [open, setOpen] = useState(false);
    const [selectedProject, setSelectedProject] = useState([]);
    const [projects, setProjects] = useState([]);

    useEffect(() => {
        setBlockName(props.name);
        Common.traceInit("Block " + blockName);
    }, [setProjects]);


    return (
        <Block name="projects" isAlt={false}>

            <TextHeader text={
                <Fragment>
                   Adreno KFC Vault
                </Fragment>
            } />

            <ContentWrapper
                header="The Adreno Sydney Kingfish up over the years 2019-2024"
                content={
                    <Fragment>
                        Since its inception the Kingfish Cup has been a tremendous popular event bringing more spearos every year!!!
                    </Fragment>
                } />

            <RecordRowTable
                year="2019"
                totalDivers="200"
                men="180"
                women="20"
                kingfishNumber="13"
                kingfishKG="156.0 kg"
                hrsDiving ="720 hrs"
                hrsPerFish="55 hrs / fish"
            />

            <RecordRowTable
                year="2020"
                totalDivers="181"
                men="162"
                women="19"
                kingfishNumber="16"
                kingfishKG="175 kg"
                hrsDiving="820 hrs"
                hrsPerFish="51 hrs / fish"
            />

            <RecordRowTable
                year="2021"
                totalDivers="165"
                men="156"
                women="9"
                kingfishNumber="12"
                kingfishKG="132 kg"
                hrsDiving="633 hrs"
                hrsPerFish="52 hrs / fish"
            />

            <RecordRowTable
                year="2022"
                totalDivers="191"
                men="180"
                women="11"
                kingfishNumber="12"
                kingfishKG="72.6 kg"
                hrsDiving="913 hrs"
                hrsPerFish="76 hrs / fish"
            />

            <RecordRowTable
                year="2023"
                totalDivers="235"
                men="218"
                women="17"
                kingfishNumber="16"
                kingfishKG="152.5 kg"
                hrsDiving="1342 hrs"
                hrsPerFish="84 hrs / fish"
            />

            <RecordRowTable
                year="2024"
                totalDivers="297"
                men="269"
                women="28"
                kingfishNumber="22"
                kingfishKG="254 kg"
                hrsDiving="1106 hrs"
                hrsPerFish="50 hrs / fish"
            />

        </Block>
    );
}
export default Records;


const ContentWrapper = (props) => {
    return (
        <Row>
            <Col lg={{ size: 10, offset: 0 }} className="">
                <p>
                    <b>{props.header}</b>
                </p>
                <p>
                    {props.content}
                </p>
            </Col>
        </Row>
    );
}


const RecordRowTable = (props) => {
    return (
        <Fragment>
            <Row>
                <Col lg={{ size: 12, offset: 0 }} className="record-header text-center">
                    <p>
                        <h2>{props.year}</h2>
                    </p>
                </Col>
            </Row>
            <Row>
                <Col lg={{ size: 12, offset: 0 }} className="table-records text-center" >
                    <table className="table">
                        <thead>
                            <tr>
                                <th>
                                    Total Participants
                                </th>
                                <th>
                                    Men
                                </th>
                                <th>
                                    Women
                                </th>
                                <th>
                                    Fish landed
                                </th>
                                <th>
                                    Total catch (kg)
                                </th>
                                <th>
                                    Total hours
                                </th>
                                <th>
                                    Effort per fish
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    {props.totalDivers}
                                </td>
                                <td>
                                    {props.men}
                                </td>
                                <td>
                                    {props.women}
                                </td>
                                <td>
                                    {props.kingfishNumber}
                                </td>
                                <td>
                                    {props.kingfishKG}
                                </td>
                                <td>
                                    {props.hrsDiving}
                                </td>
                                <td>
                                    {props.hrsPerFish}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Col>
            </Row>
            <Row>
                <Col className="spaceRow"></Col>
            </Row>
        </Fragment>
    );
}

const RecordRow = (props) => {
    return (
        <Fragment>
            <Row>
                <Col lg={{ size: 10, offset: 0 }} className="record-header text-center">
                    <p>
                        <h2>{props.year}</h2>
                    </p>
                </Col>
            </Row>
            <Row>
                <Col lg={{ size: 2 }}>
                    <p>
                        <b>Total Participants</b>
                    </p>
                </Col>
                <Col lg={{ size: 1}}>
                    <p>
                        <b>Men</b>
                    </p>
                </Col>
                <Col lg={{ size: 1 }}>
                    <p>
                        <b>Women</b>
                    </p>
                </Col>
                <Col lg={{ size: 1 }}>
                    <p>
                        <b>Fish landed</b>
                    </p>
                </Col>
                <Col lg={{ size: 2 }}>
                    <p>
                        <b>Total catch (kg)</b>
                        </p>
                    </Col>
                <Col lg={{ size: 1 }}>
                    <p>
                        <b>Total hours</b>
                    </p>
                </Col>
                <Col lg={{ size: 2 }}>
                    <p>
                        <b>Effort per fish</b>
                    </p>
                </Col>
            </Row>
            <Row>
                <Col lg={{ size: 2 }} className="text-center">
                    <p>
                        {props.totalDivers}
                    </p>
                </Col>
                <Col lg={{ size: 1 }} className="text-center">
                    <p>
                        {props.men}
                    </p>
                </Col>
                <Col lg={{ size: 1 }} className="text-center">
                    <p>
                        {props.women}
                    </p>
                </Col>
                <Col lg={{ size: 1 }} className="text-center">
                    <p>
                        {props.kingfishNumber}
                    </p>
                </Col>
                <Col lg={{ size: 2 }} className="text-center">
                    <p>
                        {props.kingfishKG}
                    </p>
                </Col>
                <Col lg={{ size: 1 }} className="text-center">
                    <p>
                        {props.hrsDiving}
                    </p>
                </Col>
                <Col lg={{ size: 2 }} className="text-center">
                    <p>
                        {props.hrsPerFish}
                    </p>
                </Col>
            </Row>
            <Row>
                <Col className="spaceRow"></Col>
            </Row>
        </Fragment>
    );
}